import React, { FC } from "react";
import { SVGProps } from '@utils';
import { SvgWrapper } from "./SvgWrapper";

export const BigArrowLeft: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="18" viewBox="0 0 13 18" fill="none">
      <path
        d="M11.0135 1.78925e-06L12.4515 1.2825L3.6436 9L12.4515 16.7175L11.0135 18L0.741856 9L11.0135 1.78925e-06Z"
        fill="#3273E1"
        fillOpacity="0.85"
      />
    </svg>
  </SvgWrapper>
);
